module.exports = __webpack_public_path__ + "static/media/phone_img.d3af1126.png";